import React from "react"
import "./styles.css"


export const Portfolio: React.FC = () =>{
  return (
    <>

   
      <div className="portfolio-section">

        <div className="portfolio-card">


            <div className="left-port-column">
                <h2>My portfolio</h2>
                <p>Work in progress [insert cool d3-graphics]</p>
              </div>

       
          
          <div className="right-port-column">

          
          </div>

        </div>



      </div>



    </>

    
    )
}